var _linearGradient, _filter;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcMailboxBubble = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 201,
    height: 136,
    viewBox: "0 0 201 136",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "x9uk64h12a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7e7e7e"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "w1pdw9t9zc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 198",
    style: {
      fill: "url(#x9uk64h12a)"
    },
    d: "M0 0h51.158v35.969H0z"
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "h3skgl5f2b",
    x: 0,
    y: 0,
    width: 201,
    height: 136,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2244"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1028",
    transform: "translate(29.036 26.198)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#h3skgl5f2b)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 161",
    width: 141,
    height: 76,
    rx: 26,
    transform: "translate(.96 .8)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 1",
    cx: 8,
    cy: 7.5,
    rx: 8,
    ry: 7.5,
    transform: "translate(131.964 .802)",
    style: {
      fill: "#fee205"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(-.036 62.802)",
    style: {
      fill: "#666"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1029"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 282",
    transform: "translate(77.423 48.517)",
    style: {
      clipPath: "url(#w1pdw9t9zc)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 156",
    d: "M51.158 32.073a5.538 5.538 0 0 1-1.021 2.242 4.512 4.512 0 0 1-3.337 1.649c-.133.007-.266 0-.4 0H4.747a4.38 4.38 0 0 1-4.27-2.56 4.7 4.7 0 0 1-.452-1.965Q-.02 17.985.009 4.525A4.461 4.461 0 0 1 4.546.006Q25.573-.006 46.6.005a4.494 4.494 0 0 1 4.453 3.512c.032.127.071.253.106.379zM5.181 3.02c.139.147.2.222.275.292q8.408 8.363 16.82 16.721a4.993 4.993 0 0 0 1.013.8 4.439 4.439 0 0 0 5.6-.805q8.4-8.338 16.782-16.689c.087-.086.164-.182.287-.319zm.245 29.908h40.2L32.97 20a34.618 34.618 0 0 1-2.47 2.63 7.25 7.25 0 0 1-7.362 1.452 7.425 7.425 0 0 1-3.038-1.947c-.663-.671-1.324-1.345-2.055-2.088L5.426 32.928m10.222-14.914L3.031 5.177v25.7l12.617-12.863m32.5-12.752-.11-.075-12.524 12.734 12.63 12.888z",
    style: {
      fill: "url(#x9uk64h12a)"
    }
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcMailboxBubble);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-mailboxBubble.a6cf6e5d3b78f17e75fa0fdc18e561a8.svg";